(function() {
    angular
        .module("globalSearchModule")
        .controller("GlobalSearchController", GlobalSearchController)

    GlobalSearchController.$inject = [
        "$rootScope",
        "$scope",
    ]

    function GlobalSearchController(
        $rootScope,
        $scope,
    ){
        "use strict"

        $rootScope.title = "Global Search | WANCO"

        $scope.globalSearch_tabs   = "device search"

    }
})()
